import zoonHeader from './zoonHeader.vue'

const zoonHeaders = {
    install(Vue){
        Vue.component('zoonHeader',zoonHeader)
    }
}
export default zoonHeaders